import * as Yup from 'yup';
import { getBooleanSchema, getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';

export const AgenciesSchema = Yup.object().shape({
  name: getStringSchema(100, 'Name'),
  agencyNbr: getStringSchema(20, 'Agency#'),
  claimsSharepointSiteId: getSelectSchema('Sharepoint Site'),
  claimsSharepointRoot: getStringSchema(255, 'Sharepoint Root'),
  isActive: getBooleanSchema('Active'),
});
